import { createReducer, on } from '@ngrx/store';

import { UpdateStatus } from '@shared/enums/update-status';
import { PmsCredentialModel } from '@shared/interfaces/pms-credential-model.interface';
import { RestChatHooksChannel } from '@shared/interfaces/rest-chat-hooks-channel';
import { RestTimerReport } from '@shared/interfaces/rest-timer-report';

import {
  getChatChannelsSuccess,
  getSystemConfig,
  getSystemConfigError,
  getSystemConfigSuccess,
  getTimerReport,
  getTimerReportError,
  getTimerReportSuccess,
  setSystemSectionExpanded,
  updateSystemConfig,
  updateSystemConfigError,
  updateSystemConfigSuccess,
} from './system-configuration.actions';

export const systemConfigurationFeatureKey = 'systemConfiguration';

export interface State {
  systemConfig: PmsCredentialModel[];
  systemConfigLoading: boolean;
  timerReportLoading: boolean;
  timerReport: RestTimerReport[];
  updateSystemStatus: UpdateStatus;
  updateSystemInProgress: boolean;
  chatHooksChannels: RestChatHooksChannel[];
  expandedSections: {
    API: boolean;
    Hooks: boolean;
    DateTime: boolean;
    TimerReport: boolean;
  };
}

export const initialState: State = {
  systemConfig: null,
  systemConfigLoading: false,
  timerReportLoading: false,
  timerReport: null,
  updateSystemStatus: null,
  updateSystemInProgress: false,
  chatHooksChannels: [],
  expandedSections: {
    API: true,
    Hooks: false,
    DateTime: false,
    TimerReport: false,
  },
};

export const reducer = createReducer(
  initialState,
  on(getSystemConfig, (state, action) => ({ ...state, systemConfigLoading: true })),
  on(getSystemConfigSuccess, (state, action) => ({
    ...state,
    systemConfigLoading: false,
    systemConfig: action.systemConfig,
  })),
  on(getSystemConfigError, (state, action) => ({
    ...state,
    systemConfigLoading: false,
    systemConfig: null,
  })),
  on(getTimerReport, (state, action) => ({ ...state, timerReportLoading: false })),
  on(getTimerReportSuccess, (state, action) => ({
    ...state,
    timerReportLoading: false,
    timerReport: action.timerReport,
  })),
  on(getTimerReportError, (state, action) => ({
    ...state,
    timerReportLoading: false,
    timerReport: null,
  })),

  on(updateSystemConfig, (state, action) => ({
    ...state,

    updateSystemStatus: UpdateStatus.IN_PROGRESS,
    updateSystemInProgress: true,
  })),
  on(updateSystemConfigSuccess, (state, action) => ({
    ...state,
    updateSystemStatus: UpdateStatus.UPDATED,
    updateSystemInProgress: false,
  })),
  on(updateSystemConfigError, (state, action) => ({
    ...state,
    updateSystemStatus: UpdateStatus.ERROR,
    updateSystemInProgress: false,
  })),
  on(getChatChannelsSuccess, (state, action) => ({
    ...state,
    chatHooksChannels: action.channels,
  })),
  on(setSystemSectionExpanded, (state, action) => ({
    ...state,
    expandedSections: {
      ...state.expandedSections,
      [action.section]: action.state,
    },
  }))
);
